import classNames from 'classnames'
import { getPosition } from 'components/FormMessage/position'
import Icon from 'components/Icon'
import { Colour } from 'components/variables'
import { UI } from 'Icon/ui'
import * as React from 'react'
import Portal from 'react-minimalist-portal'

import './FormMessage.scss'

export enum FormMessageType {
  Error = 'error',
  Info = 'info',
  Note = 'note',
  InfoRelative = 'info-relative',
}

export enum AlignType {
  right = 'right',
  left = 'left',
}

interface FormMessageProps {
  show?: boolean
  align?: AlignType
  type: FormMessageType
  fixed?: boolean
  icon?: JSX.Element
  colour?: Colour
  onClose?: () => void
  clossable?: boolean
  className?: string
  children?: React.ReactNode | undefined
}

interface FormMessageState {
  left?: number
  top?: number
  bottom?: string
}

class FormMessage extends React.Component<FormMessageProps, FormMessageState> {
  public static defaultProps: Partial<FormMessageProps> = {
    show: true,
    align: AlignType.left,
    clossable: true,
  }
  private tip?: HTMLDivElement
  private target?: HTMLDivElement
  private targetTop: number = 0
  constructor(props: FormMessageProps) {
    super(props)
    this.state = {
      left: -100000,
      bottom: '',
    }
  }

  public setTip = (tip: HTMLDivElement) => {
    this.tip = tip
  }

  public setTarget = (target: HTMLDivElement) => {
    this.target = target
  }

  public componentDidMount() {
    this.setTipPosition()
  }

  public componentDidUpdate(oldProps: FormMessageProps) {
    if (
      oldProps.show !== this.props.show ||
      (this.target &&
        this.target.getBoundingClientRect().top !== this.targetTop)
    ) {
      this.targetTop = this.target ? this.target.getBoundingClientRect().top : 0
      this.setTipPosition()
    }
  }

  public render() {
    const className = classNames(
      'form-message',
      `type-${this.props.type.toString()}`,
      this.props.align ? `align-${this.props.align.toString()}` : '',
      this.props.fixed ? `position-fixed` : '',
      this.props.colour,
      this.props.className,
    )

    const portal = [
      FormMessageType.Note,
      FormMessageType.InfoRelative,
    ].includes(this.props.type)
    const Tag = portal ? React.Fragment : Portal
    const style = portal ? {} : this.state

    return (
      <div ref={this.setTarget}>
        <Tag>
          <div className={className} style={style} ref={this.setTip}>
            {this.props.icon ? <Icon icon={this.props.icon} /> : null}

            {this.props.clossable ? (
              <button onClick={this.props.onClose}>
                <Icon icon={UI.cross} />
              </button>
            ) : null}

            {this.props.children}
          </div>
        </Tag>
      </div>
    )
  }

  private setTipPosition = () => {
    const state = {
      showTip: this.props.show && this.target && this.tip,
    }
    const tipPosition = getPosition(
      this.tip,
      this.target,
      state,
      this.props.align || 'left',
      this.props.type,
      this.props.fixed,
    )
    this.setState(tipPosition)
  }
}

export default FormMessage
